import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsappButton = () => {
  const phoneNumber = "919327708369";
  const message = "Hi Gopi, I'd like to talk about a project!";
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-16 right-6 sm:bottom-8 sm:right-8 z-[9999] bg-[#25D366] text-white p-3 sm:p-4 rounded-full shadow-2xl hover:scale-110 transition-transform duration-300 flex items-center justify-center group"
      aria-label="Chat on WhatsApp"
    >
      <img 
        src="/assets/images/whatsapp.webp" 
        alt="WhatsApp" 
        className="whatsapp-zoom w-8 h-8 sm:w-10 sm:h-10 object-contain" 
      />
      <span className="absolute right-full mr-3 bg-white text-gray-800 px-3 py-1 rounded-lg text-sm font-medium shadow-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap pointer-events-none">
        Chat with me
      </span>
    </a>
  );
};

export default WhatsappButton;
